import getBITSEndApiMap from "../apiMap";
import { api } from "../services/AxiosService";

function buildUrl(template: string, params: Record<string, string | number>) {
  return template.replace(/:([a-zA-Z0-9_]+)/g, (_, key) =>
    String(params[key] ?? ":" + key)
  );
}

// Types
export type GroupImportFormat = "csv" | "xlsx";

export type GroupValidationResponse = {
  success: boolean;
  valid: boolean;
  message: string;
  summary: {
    totalGroups: number;
    totalMembers: number;
    validGroups: number;
  };
  errors?: {
    rowErrors: any[];
    userErrors: Array<{
      row: number;
      email: string;
      type: string;
      message: string;
    }>;
    groupErrors: any[];
  };
};

export type GroupImportResponse = {
  isSuccess: boolean;
  message: string;
  data: {
    groupsCreated: number;
    membersAdded: number;
    groups: Array<{
      groupId: string;
      groupName: string;
      groupCode: string;
      memberCount: number;
      leader: string;
    }>;
  };
};

// API Functions
export async function downloadGroupImportTemplate(
  projectId: string,
  format: GroupImportFormat = "csv"
): Promise<Blob> {
  const urlTemplate = getBITSEndApiMap("downloadGroupImportTemplate");
  const url = buildUrl(urlTemplate, { projectId });
  const fullUrl = `${url}?format=${format}`;

  const { data } = await api.get(fullUrl, {
    responseType: "blob",
  });

  return data;
}

export async function validateGroupImportFile(
  projectId: string,
  file: File
): Promise<GroupValidationResponse> {
  const urlTemplate = getBITSEndApiMap("validateGroupImport");
  const url = buildUrl(urlTemplate, { projectId });

  const formData = new FormData();
  formData.append("file", file);

  const { data } = await api.post<GroupValidationResponse>(url, formData);
  return data;
}

export async function importGroupsFromFile(
  projectId: string,
  file: File
): Promise<GroupImportResponse> {
  const urlTemplate = getBITSEndApiMap("importGroups");
  const url = buildUrl(urlTemplate, { projectId });

  const formData = new FormData();
  formData.append("file", file);

  const { data } = await api.post<GroupImportResponse>(url, formData);
  return data;
}

export async function deleteProjectFileById(projectId: string): Promise<void> {
  const url = `${getBITSEndApiMap("deleteImportedGroups").replace(":projectId", projectId)}`;
  await api.delete(url);
}
